export const ADD_DASHBOARD_SUMMARY = "ADD_DASHBOARD_SUMMARY";
export const DASHBOARD_START_LOADER = "DASHBOARD_START_LOADER";
export const DASHBOARD_STOP_LOADER = "DASHBOARD_STOP_LOADER";
export const DASHBOARD_HIDE_ERROR = "DASHBOARD_HIDE_ERROR";
export const DASHBOARD_ERROR = "DASHBOARD_ERROR";
